import { styled, Box, Popper, MenuItem, SvgIcon } from "@mui/material";

export const Wrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    marginRight: '15px',
  }));
  
  export const StyledPopper = styled(Popper)(({ theme }) => ({
    zIndex: 999,
    marginTop: '12px',
  }));
  
  export const StyledBox = styled(Box)(({ theme }) => ({
    color: theme.palette.secondary.main,
    padding: '10px',
    backgroundColor: theme.palette.primary.dark,
    width: '300px',
    position: 'relative',
  }));
  
  export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    padding: '15px',
    backgroundColor: theme.palette.primary.dark,
    fontSize: '12px',
  }));
  
  export const StyledIcon = styled(SvgIcon)(({ theme }) => ({
    width: '36px',
    height: '36px',
    color: theme.palette.success.main,
    marginRight: '5px',
  }));
  
  export const Arrow = styled('span')(({ theme }) => ({
    position: 'absolute',
    top: '-8px',
    right: '15px',
    width: 0,
    height: 0,
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderBottom: `8px solid ${theme.palette.primary.dark}`,
  }));
  
  export const StyledAppsIcon = styled(SvgIcon)(({ theme }) => ({
    width: '36px',
    height: '36px',
    marginLeft: '5px',
  }));